import React from 'react'
import { FaRegBuilding, FaRegCreditCard, FaUniversity } from 'react-icons/fa'
import { Card, CardBody, CardTitle, Col, Row } from 'reactstrap'

const BankDetails = ({user}) => {
  return (
    <Row className="justify-content-center mt-4">
    <Col md="12" sm="12">
      <Card className="shadow">
        <CardBody>
          <CardTitle tag="h2" className="">
            Bank Details
          </CardTitle>
          {user.upiId ? (
            <Row className="mb-2">
              <Col md="4" sm="4">
                <FaRegCreditCard /> <strong>UPI ID:</strong>
              </Col>
              <Col md="8" sm="8">{user?.buddyDetails?.bankDetails?.upiId}</Col>
            </Row>
          ) : (
            <>
              <Row className="mb-2">
                <Col md="4" sm="4">
                  <FaRegCreditCard /> <strong>A/C Number:</strong>
                </Col>
                <Col md="8" sm="8">{user?.buddyDetails?.bankDetails?.acNumber}</Col>
              </Row>
              <Row className="mb-2">
                <Col md="4" sm="4">
                  <FaUniversity /> <strong>IFSC Code:</strong>
                </Col>
                <Col md="8" sm="8">{user?.buddyDetails?.bankDetails?.ifscCode}</Col>
              </Row>
              <Row className="mb-2">
                <Col md="4" sm="4">
                  <FaRegBuilding /> <strong>Branch Address:</strong>
                </Col>
                <Col md="8" sm="8">{user?.buddyDetails?.bankDetails?.branchDetails}</Col>
              </Row>
              <Row className="mb-2">
                <Col md="4" sm="4">
                  <FaUniversity /> <strong>Bank Name:</strong>
                </Col>
                <Col md="8" sm="8">{user?.buddyDetails?.bankDetails?.bankName}</Col>
              </Row>
              <Row className="mb-2">
                <Col md="4" sm="4">
                  <FaUniversity /> <strong>Account Holder Name:</strong>
                </Col>
                <Col md="8" sm="8">{user?.buddyDetails?.bankDetails?.accountHolderName}</Col>
              </Row>
            </>
          )}
        </CardBody>
      </Card>
    </Col>
  </Row>
  )
}

export default BankDetails